import React, { useState } from "react";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import {
    checkImage,
} from "../../../helper/ImageFormat";
const Image_Url = process.env.REACT_APP_CDN_URL
const UploadFileTable = ({
    loading,
    media,
    currentPage,
    perPage,
    totalCount,
    totalPages,
    handlePageClick,
    handleDelete
}) => {
    const [copiedId, setCopiedId] = useState(null);

    const handleCopyPath = async (path, id) => {
        try {
            const fullUrl = `${Image_Url}${path}`;
            await navigator.clipboard.writeText(fullUrl);
            setCopiedId(id);
            setTimeout(() => setCopiedId(null), 2000);
        } catch (err) {
            return err
        }
    };

    return (
        <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table
                                className="custom-table table table-striped"
                                id="myTable"
                                style={{ marginTop: "3px" }}
                            >
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Image</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <Spinner />
                                            </td>
                                        </tr>
                                    ) : media?.length > 0 ? (
                                        media.map((data, id) => (
                                            <tr key={data.id}>
                                                <td>{data.name}</td>
                                                <td>{data.type}</td>
                                                <td>{checkImage(data.path)}</td>
                                                <td className="d-flex align-items-center" style={{ gap: "4px" }}>
                                                    <div
                                                        style={{
                                                            background:
                                                                copiedId === data.id
                                                                    ? "rgba(99, 221, 99, 0.15)"
                                                                    : "rgba(255, 108, 47, 0.1)",
                                                            padding: "5px",
                                                            borderRadius: "5px",
                                                        }}
                                                        title={copiedId === data.id ? "Copied!" : "Copy file URL"}
                                                        onClick={() => handleCopyPath(data.path, data.id)}
                                                    >
                                                        <i
                                                            className={copiedId === data.id ? "fa-solid fa-check" : "fa-regular fa-copy"}
                                                            style={{
                                                                cursor: "pointer",
                                                                color:
                                                                    copiedId === data.id
                                                                        ? "rgba(99, 221, 99, 1)"
                                                                        : "rgb(38, 94, 215)",
                                                                padding: "5px",
                                                                fontSize: "18px",
                                                                transition: "all 0.3s ease",
                                                            }}
                                                        />
                                                    </div>

                                                    <div
                                                        style={{
                                                            background: "rgba(255, 0, 0, 0.1)",
                                                            padding: "5px",
                                                            borderRadius: "5px",
                                                        }}
                                                        title="Delete file"
                                                    onClick={() => handleDelete(data)}
                                                    >
                                                        <i
                                                            className="fa-solid fa-trash-can"
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "rgba(255, 77, 107, 1)",
                                                                padding: "5px",
                                                                fontSize: "18px",
                                                                transition: "all 0.3s ease",
                                                            }}
                                                        />
                                                    </div>
                                                </td>



                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <h4>No data available</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {media?.length > 0 && (
                            <div>
                                <CustomPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageClick}
                                    perPage={perPage}
                                    totalCount={totalCount}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadFileTable;
